import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Row } from 'reactstrap';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';
import { Tooltip, Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AddOrUpdateTagModal from '../../AddOrUpdate/AddOrUpdateTagModal';

const CustomerDeliveryTagDetails = ({ 
  reactTableData, 
  isNoRecordFound,
  totalElements,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange
}) => {
  const [rows, setRows] = useState([]);
  const { t } = useTranslation('common');

  useEffect(() => {
    if (reactTableData && reactTableData.tableRowsData) {
      setRows(reactTableData.tableRowsData);
    } else {
      setRows([]);
    }
  }, [reactTableData]);

  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: true,
    withPagination: true,
    withSearchEngine: true,
    manualPagination: true, // Crucial for server-side pagination
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search by Customer Name, Customer Code...',
  };

  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);

  const Add = () => {
    setViewDetailPopup(true);
    setTitle("Customer Delivery Tag Mapping");
  }

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <Row>
            <Col md={12}>
              <h3 className="page-title">Customer Details</h3>
            </Col>
          </Row>
          <Tooltip title="Click here to add new details">
            <Fab 
              size="large" 
              color="primary" 
              aria-label="add" 
              style={{ float: "right", backgroundColor: "#32CA73", color: "white", marginBottom: '16px' }} 
              onClick={() => Add()}
            >
              <AddIcon />
            </Fab>
          </Tooltip>
          {!isNoRecordFound && (
            <ReactTableBase
              name={t('instution_type.view.name_map')}
              key={'searchable'}
              columns={reactTableData.tableHeaderData}
              data={rows}
              tableConfig={tableConfig}
              totalDataCount={totalElements}
              pageIndex={page}
              pageSize={pageSize}
              onPageChange={onPageChange}
              onPageSizeChange={onPageSizeChange}
            />
          )}
          {viewDetailPopup && (
            <AddOrUpdateTagModal
              modalShow={viewDetailPopup}
              setModalShow={setViewDetailPopup}
              isTitle={isTitle} 
            />
          )} 
        </CardBody>
      </Card>
    </Col>
  );
};

CustomerDeliveryTagDetails.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  isNoRecordFound: PropTypes.bool,
  totalElements: PropTypes.number,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
};

export default CustomerDeliveryTagDetails;
